module.exports = __webpack_public_path__ + "static/img/filter_icon_active.a77db452.svg";